module.exports = __webpack_public_path__ + "img/header-3.b687fd1b.png";